{
  "cc":"This work is licensed under a Creative Commons Attribution-NonCommercial 4.0 International (CC BY-NC).",
  "language": "Language selection",
  "unexpected_error": "Unexpected error! Please save the answers to local disk and try again later!",
  "back": "Back",
  "invalid_file": "The uploaded file was invalid. Please try again.",
  "conformation_internet": "The latest questionnaire will be downloaded using the Internet.",
  "conformation_benchmark": "The latest benchmark will be downloaded using the Internet.",
  "conformation_internet2": "Data will be uploaded to database. The application forwards the request over the Internet.",
  "back_2": "Back",
  "back_answering": "Back to answering",
  "download": "Download to local disk ",
  "conformation_incomplete_q": "This status will be deleted. Save detailed answers to local disk to continue later.",
  "continue": "Continue",
  "end": "End",
  "green": "The attribute is completely true in the context of your organization",
  "to_start": "To start page",
  "incomplete": "Some questions remain unanswered!",
  "version" : "Questionnaire version",
  "introduction": {
    "header": "Organisation's information security maturity level evaluation",
    "time_estimate": "We thank you for evaluating the maturity of your organisation's information security management with our tool. The completion of the workflow is expected to take 30-70 min.",
    "evaluation": "The evaluation is based on the Estonian Information Security Standard (E-ITS https://eits.ria.ee), ENISA 2022 Threat Landscape Report (DOI: 10.2824/764318) recommendations and covers ISO27002:2022 control objectives.",
    "apply": "After evaluating all statements, the respondent will receive immediate overview of the information security management system situation of their organisation as a downloadable file and as a visual graph. The graph contains ten information security management dimensions that can be used for further planning of the orgainsation's information security management.",
    "principles": "Principles:",
    "principle_1": "* Detailed answers exist only on the respondent's computer, meaning in your device.",
    "principle_2": "* If you agree to transmitting the aggregated numerical values of your organisation's maturity to the server , we will also provide a benchmark. The benchmark can be used to compare your organisation's results with other organisations' average results (if available on the server at that point).",
    "principle_3": "* It is possible to save the answers to your computer (see \"Home\" button) to continue answering later or review previous answers.",
    "principle_4": "* With your consent, only the average number values of the responses and the information you provide about the organisation will be transmitted to the server. Before sending it to the server, you can review and save the data that is transmitted.",
    "data_processing": "Principles of data processing:",
    "data_processing_1": "* The email address is only used to inform participants when a new version of the questionnaire or new benchmark data has been published.",
    "data_processing_2": "* The name of the organisation is necessary to specify the domain, identify duplicate results and monitor the dynamics of the results in repeated evaluations.",
    "data_processing_3": "* The results, averaged by security maturity level, are analysed and presented without the names of the participating organisations.",
    "data_processing_4": "* Evaluation results in the context of a single institution will only be used anonymously. The average results based on the domain, i.e. the area of activity and the size of the institution, will only be published if the measurement results are from at least five institutions belonging to the corresponding group.",
    "data_processing_5": "* In cooperation with Estonian National Cyber Security Centre (RIA, NCSC-EE), researchers will use the data for research and develop a domain-based and general benchmark at the national level.",
    "developers": "The principles of the maturity evaluation framework (F4SLE) is developed by Mari Seeba (UT, RIA).  The measuring tool (MASS) is developed by Maria Pibilota Murumaa (UT, Cybernetica AS) under the supervision of Mari Seeba and Tarmo Oja. Tarmo Oja (UT, Cybernetica AS), Vaclav Matyas (MUNI) ja Vaclav Stupka (MUNI) are involved as experts. The measurement project is a mini-project of the CHESS research collaboration project in Estonia and South Moravia in Czech Republic.",
    "contact": "Contact us if you have any questions ",
    "processor": "Responsible data processor:",
    "ut": " University of Tartu.",
    "disclaimer": "Funded by the European Union under Grant Agreement No. 101087529. Views and opinions expressed are however those of the author(s) only and do not necessarily reflect those of the European Union or European Research Executive Agency. Neither the European Union nor the granting authority can be held responsible for them."
  },
  "more_info": "Additional information",
  "new_questionnaire": "Start a new questionnaire",
  "next": "Next",
  "no_answer": "Not answering",
  "not_applicable": "Not applicable",
  "orange": "The attribute is partially in accordance with the description of the situation, but still with significant shortcomings",
  "red": "Nothing significant has yet been done for the situation described in the attribute",
  "results": {
    "maturity_levels":"Maturity levels",
    "more": "When submitting the averaged numerical values of the answers to the database, the averaged results of other organizations will be displayed next to the results of your organization. To do this, press the following button:",
    "save_local": "Save detailed answers to local disk",
    "save_summary_local": "Save summary metadata to local disk",
    "goal": "Goal",
    "results": "Results",
    "initial": "Initial",
    "defined": "Defined",
    "basic": "Basic",
    "standard": "Standard",
    "benchmark_results": "Results compared to benchmark",
    "initiated_description": "Good practices have not been implemented, risks have not been recognized, and management has not taken the initiative. Security activities are sporadic and instead initiated at the grassroots level.",
    "defined_description": " Processes and activities are initiated on an ad hoc basis. Documents have been prepared but are partially outdated or do not correspond to reality. ",
    "basic_description": "Practices work and are documented, resources are planned, and roles and responsibilities are allocated. Regularity of activities has not yet been achieved.",
    "standard_description": "Organizational policies and principles are clear. Activities are monitored and traceable, and activities are standardized and documented. Continuous improvement is taking place. Exceptions are monitored.",
    "initial_range": "<0.75 INITIATED",
    "defined_range": ">=0.75 and <1.5 DEFINED",
    "basic_range": ">=1.5 and <2.25 BASIC",
    "standard_range": ">2.25 STANDARD",
    "initiated_description2": " The need to deal with information security has been acknowledged and addressed. ",
    "defined_description2": "Formal processes have been agreed, and the necessary information security supporting documents have been prepared.",
    "basic_description2": "Practical basic activities have been implemented to manage information security ",
    "standard_description2": "There are clear organisational policies and principles. Activities are standardised, documented, regular and monitored. There is ongoing monitoring and improvement. ",
    "initiated": "INITIATED",
    "process_dim":"Process dimensions",
    "system_dim":"System dimensions",
    "PDF":"Generate PDF",
    "send_data":"Send data to server and load benchmarks"
  },
  "send_results": {
    "more_info":"The principles of data processing can be found here",
    "validation": "False or missing input for values:",
    "description": "Collecting feedback and data",
    "token": "Token",
    "feedback": "Feedback",
    "db_address": "Database address",
    "send": "Send result",
    "back": "Back",
    "info_sent": "Preview of information sent to database",
    "loading": "Loading",
    "time_estimate": "Time taken to respond to the questionnaire *",
    "send_database": "Results sent to database",
    "time": "Spent time",
    "thank_you": "Thank you for your input!",
    "success": "Information has been successfully sent to database!",
    "home": "Home page",
    "email": "Email (used for notifications e.g. new benchmark, questionnaire)",
    "role": "Role  *",
    "it_dep":"The number of people involved in  information security or IT management within the organisation *",
    "it_dep_explanation": "Count all people who spend 50% or more of their time working on IT management or information security.",
    "role_list": {
      "management": "Top management",
      "auditor": "Auditor",
      "info_manager": "Information security manager /specialist",
      "IT_manager": "IT manager",
      "network": "Network/system administrator",
      "admin": "Aadministrative assistant/lawyer/DPO",
      "other": "Other"
    },
    "org_name": "Organisation name  *",
    "domain": "Organisation domain  *",
    "other_role": "Input role *",
    "other_domain": "Input domain *",
    "other_country_2": "Input country *",
    "domain_list": {
      "healthcare": "Healthcare",
      "education": "Education and research",
      "municipality": "Municipality",
      "ICT": "ICT",
      "non-profit": "Non-profit",
      "finance": "Financial",
      "digital_service": "Digital infrastructure",
      "energy": "Energy",
      "water_heating": "Water and district heating",
      "transport": "Transport",
      "other": "Other",
      "public_admin": "Public administration",
      "space": "Space",
      "postal": "Postal and courier services",
      "waste": "Waste management",
      "chemicals": "Manufacture, production and distribution of chemicals",
      "food": "Production, processing and distribution of food",
      "manufactoring": "Manufacturing",
      "digi": "Digital providers"
    },
    "workplaces": "Number of staff  *",
    "time_list": {
      "30_minutes": "Around 30 minutes",
      "1_hour": "Around 1 hour",
      "2_hours": "2 hours",
      "4_hours": "2-4 hours",
      "8_hours": "4-8 hours",
      "workday": "More than 1 working day"
    },
    "standard": "Implemented standards",
    "country": "Country *",
    "estonia": "Estonia",
    "czech": "Czech Republic",
    "other_country": "Other",
    "standard_list": {
      "ISO": "ISO/IEC 27001",
      "NIST": "NIST CSF",
      "CIS": "CIS Controls",
      "ISKE": "ISKE (Estonian)",
      "KYTS": "KüTS (Estonian)",
      "BSI": "BSI IT Grundshutz (German)",
      "EITS": "E-ITS (Estonian)",
      "CzechAct":"Act on cyber security, no. 181/2014 Coll. (Czech)"
    },
    "refuse": "Do not wish to participate in data collection"
  },
  "unfinished_questionnaire": "Open an existing answer file from local disk",
  "upload_file_text": "Please select a .txt file to open:",
  "yellow": "The attribute is reasonably addressed with your organization, but with some shortcomings",
  "result_upload": "Open an existing result file from local disk"
}